
import { Controller } from "stimulus"
import RequestQueue from 'classes/RequestQueue';
import Events from 'classes/Events';
import _ from 'lodash';

class Crud extends Controller {
  static targets = [
    'resultContainer'
  ]

  create = async e => {
    e.preventDefault();
    const apiUrl = this.data.get('apiUrl');
    const apiData = JSON.parse(this.data.get('apiData'));
    const response = await RequestQueue.addToQueue({
      url: apiUrl,
      method: 'post',
      data: apiData
    })
    if (response.data && response.data.status == 'success') {
      this.resultContainerTarget.dispatchEvent(Events.changeEvent)
    } else {
      console.log('error occured on creation')
    }
  }

  delete = async e => {
    e.preventDefault();
    const { target } = e;
    const apiUrl = target.getAttribute('data-api-url');
    const apiMethod = target.getAttribute('data-api-method');
    const apiData = JSON.parse(target.getAttribute('data-api-data'));
    const response = await RequestQueue.addToQueue({
      url: apiUrl,
      method: apiMethod,
      data: apiData
    })
    if (response.data && response.data.status == 'success') {
      this.resultContainerTarget.dispatchEvent(Events.changeEvent)
    } else {
      console.log('error occured on removing')
    }
  }

  updateApiData = e => {
    const { target } = e;
    const { value } = target;
    const attributeKey = target.getAttribute('name');
    const currentDataString = this.data.get('apiData');
    if (_.isEmpty(currentDataString)) {
      this.data.set('apiData', JSON.stringify({ [attributeKey]: value }))
    } else {
      const currentData = JSON.parse(currentDataString);
      currentData[attributeKey] = value;
      this.data.set('apiData', JSON.stringify(currentData));
    }
  }
}

export default Crud;
